import { render, staticRenderFns } from "./form.vue?vue&type=template&id=bbddd18c&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=bbddd18c&prod&lang=stylus&scoped=true&"
import style1 from "./form.vue?vue&type=style&index=1&id=bbddd18c&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbddd18c",
  null
  
)

export default component.exports